/**
 * Which screen a path shows. The exercises and the one open beside them are
 * one screen: picking another must neither remount it nor scroll it back up.
 */
export function screenOf(pathname: string): string {
  return pathname.startsWith("/reglages/exercices") ? "/reglages/exercices" : pathname;
}
